import { useLayoutEffect } from 'react';
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const useBrowserLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : () => {};
